import React from 'react';
import { FaArrowLeftLong } from 'react-icons/fa6';
import Navigation from '../../../layout/Navigation/Navigation';
import UseUserProfilePage from './UseUserProfilePage';
import { GrGallery } from 'react-icons/gr';
import Select from 'react-select';

const UserProfilePage: React.FC = () => {
  const {
    handleSubmit,
    handleChange,
    fileInputRef,
    handleFileChange,
    handleButtonClick,
    states,
    handleChangeBusineType,
    handleCustomerGroup,
    navigate,
  } = UseUserProfilePage();

  return (
    <div className='  bg-white px-5 sm:px-5 md:px-6 lg:px-6 py-3 sm:py-3 md:py-6 lg:py-12 '>
      {/* Mobile(Sm MD) veiw */}
      <div className='block sm:block md:block lg:hidden'>
        <div className='px-2 text-lg font-semibold flex items-center font-poppins'>
          <FaArrowLeftLong onClick={() => navigate(-1)} className='mr-3' />
          Personal Information
        </div>
      </div>
      <div className='flex items-center justify-center mt-4 sm:mt-4 md:mt-4 lg:mt-0'>
        <div className='flex flex-col lg:flex-row bg-white w-full max-w-7xl rounded-xl sm:rounded-xl md:rounded-xl xl:rounded-xl overflow-hidden gap-0 sm:gap-0 md:gap-2 lg:gap-6 shadow_box '>
          {/* Global Navigation */}
          <Navigation />

          <div className='flex-1 bg-white  mb-4 sm:mb-4 md:mb-4 lg:mb-0'>
            {/* Personal Information */}
            <form onSubmit={handleSubmit}>
              <div className='mb-0 sm:mb-0 md:mb-2 lg:mb-6  border-container rounded-xl '>
                <div className='hidden sm:hidden md:hidden lg:block justify-between items-center py-3 px-6 border-b'>
                  <h1 className='text-xl text-[#1A1A1A] font-medium font-poppins'>Personal Information</h1>
                </div>
                {/* Main Grid Row */}
                <div className='grid grid-cols-1 lg:grid-cols-12 gap-0 sm:gap-0 md:gap-0 lg:gap-4 py-3 sm:py-3 md:py-3 lg:py-6'>
                  <div className='lg:col-span-5 flex flex-col items-center justify-center gap-4 order-1 lg:order-2 my-2 sm:my-2 md:my-2 lg:my-0'>
                    <div
                      className='size-20 sm:size-20 md:size-24 lg:size-24 rounded-full flex items-center justify-center bg-[#E6EDF5]'
                      onClick={handleButtonClick}
                    >
                      {states.profileImageVal ? (
                        <img
                          className='size-20 sm:size-20 md:size-24 lg:size-24 object-contain rounded-full cursor-pointer flex items-center justify-center'
                          src={states.profileImageVal}
                          alt='Profile'
                        />
                      ) : (
                        <div className='icon-placeholder'>
                          <GrGallery className='size-8 sm:size-8 md:size-12 lg:size-12 ' />
                        </div>
                      )}
                    </div>

                    <input
                      type='file'
                      ref={fileInputRef}
                      name='profileImage'
                      value=''
                      accept='.jpg,.jpeg,.png,.webp'
                      onChange={handleFileChange}
                      className='hidden'
                    />

                    <button
                      type='button'
                      onClick={handleButtonClick}
                      className='border border-[#C12E2A] text-[#C12E2A] px-4 py-2 rounded-md font-poppins cursor-pointer hover:bg-red-100 hidden sm:hidden md:hidden lg:block font-medium'
                    >
                      Choose Image
                    </button>
                  </div>

                  {/* Form Fields Section - appears second on small screens */}
                  <div className='lg:col-span-7 space-y-4 px-4 sm:px-4 md:px-6 lg:px-6 order-2 lg:order-1'>
                    <div>
                      <label className='block mb-1 text-sm sm:text-sm md:text-base lg:text-base font-poppins text-[#1A1A1A]'>
                        First Name
                      </label>
                      <input
                        type='text'
                        name='firstName'
                        placeholder='Enter first name'
                        value={states.formData.firstName}
                        onChange={handleChange}
                        className='w-full border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg text-sm sm:text-sm md:text-base lg:text-base font-poppins'
                      />
                      {states.errors.firstName && (
                        <p className='text-red-500 text-sm font-poppins'>{states.errors.firstName}</p>
                      )}
                    </div>
                    <div>
                      <label className='block mb-1 text-sm sm:text-sm md:text-base lg:text-base font-poppins text-[#1A1A1A]'>
                        Phone Number
                      </label>
                      <input
                        type='text'
                        name='phoneNumber'
                        placeholder='Enter mobile number'
                        value={states.formData.phoneNumber}
                        onChange={handleChange}
                        className='w-full border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg text-sm sm:text-sm md:text-base lg:text-base font-poppins'
                      />
                      {states.errors.phoneNumber && (
                        <p className='text-red-500 text-sm font-poppins'>{states.errors.phoneNumber}</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className='block sm:block md:block lg:hidden justify-between items-center px-4 sm:px-4 md:px-6 py-2  '>
                <h1 className='text-lg font-semibold font-poppins'>Location Information</h1>
              </div>
              {/* Location Information */}
              <div className='mb-2 sm:mb-2 md:mb-6 lg:mb-6 border-container rounded-xl '>
                <div className='hidden sm:hidden md:hidden lg:block justify-between items-center py-3 px-6 border-b'>
                  <h1 className='text-xl text-[#1A1A1A] font-medium font-poppins'>Location Information</h1>
                </div>
                <div className='space-y-4 text-sm sm:text-sm md:text-base lg:text-base font-poppins px-4 sm:px-4 md:px-6 lg:px-6 mt-0 sm:mt-0 md:mt-0 lg:mt-4'>
                  <div>
                    <label className='block mb-1 text-[#1A1A1A]'>Shop Name</label>
                    <input
                      type='text'
                      name='shopName'
                      placeholder='Enter shop name'
                      value={states.formData.shopName}
                      onChange={handleChange}
                      className='w-full border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg'
                    />
                    {states.errors.shopName && (
                      <p className='text-red-500 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                        {states.errors.shopName}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className='block mb-1 text-[#1A1A1A]'>Address Line-1</label>
                    <input
                      type='text'
                      name='address1'
                      placeholder='Enter address line-1'
                      value={states.formData.address1}
                      onChange={handleChange}
                      className='w-full border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg'
                    />
                    {states.errors.address1 && (
                      <p className='text-red-500 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                        {states.errors.address1}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className='block mb-1 text-[#1A1A1A]'>Address Line-2</label>
                    <input
                      type='text'
                      name='address2'
                      placeholder='Enter address line-2'
                      value={states.formData.address2}
                      onChange={handleChange}
                      className='w-full border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg'
                    />
                    {states.errors.address2 && (
                      <p className='text-red-500 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                        {states.errors.address2}
                      </p>
                    )}
                  </div>

                  <div>
                    <label className='block mb-1 text-[#1A1A1A]'>City</label>
                    <input
                      type='text'
                      name='city'
                      placeholder='Enter City'
                      value={states.formData.city}
                      onChange={handleChange}
                      className='w-full border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg'
                    />
                    {states.errors.city && (
                      <p className='text-red-500 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                        {states.errors.city}
                      </p>
                    )}
                  </div>
                </div>

                <div className='grid grid-cols-1 md:grid-cols-3 gap-4 px-4 sm:px-4 md:px-6 lg:px-6 mb-2 sm:mb-2 md:mb-2 lg:mb-6 mt-3 sm:mt-3 md:mt-4 lg:mt-4 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                  <div>
                    <label className='block mb-1 text-[#1A1A1A]'>State</label>
                    <select
                      name='state'
                      value={states.formData.state}
                      onChange={handleChange}
                      className='w-full border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg bg-white'
                    >
                      <option value=''>Select state</option>
                      {states.stateList &&
                        states.stateList.map(state => (
                          <option key={state} value={state}>
                            {state}
                          </option>
                        ))}
                    </select>
                    {states.errors.state && (
                      <p className='text-red-500 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                        {states.errors.state}
                      </p>
                    )}
                  </div>

                  <div>
                    <label className='block mb-1 text-[#1A1A1A]'>Country</label>
                    <select
                      name='country'
                      value={states.formData.country}
                      onChange={handleChange}
                      disabled
                      className='w-full border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg bg-gray-100'
                    >
                      <option value=''>Select country</option>
                      {states.countryList &&
                        states.countryList.map(country => (
                          <option key={country.name} value={country.name}>
                            {country.name}
                          </option>
                        ))}
                    </select>
                    {states.errors.country && (
                      <p className='text-red-500 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                        {states.errors.country}
                      </p>
                    )}
                  </div>

                  <div>
                    <label className='block mb-1 text-[#1A1A1A]'>Pincode</label>
                    <input
                      type='text'
                      name='pincode'
                      placeholder='Enter pincode'
                      value={states.formData.pincode}
                      onChange={handleChange}
                      className='w-full border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg'
                    />
                    {states.errors.pincode && (
                      <p className='text-red-500 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                        {states.errors.pincode}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div className='block sm:block md:block lg:hidden justify-between items-center px-4 sm:px-4 md:px-6 py-2'>
                <h1 className='text-lg font-semibold font-poppins'>Other Information</h1>
              </div>

              {/* Other Information */}
              <div className='mb-0 sm:mb-0 md:mb-0 lg:mb-4 border-container rounded-xl'>
                <div className='hidden sm:hidden md:hidden lg:block justify-between items-center py-3 px-4 border-b'>
                  <h1 className='text-xl text-[#1A1A1A] font-medium font-poppins'>Other Information</h1>
                </div>
                <div className='gap-4 px-4 sm:px-4 md:px-6 lg:px-6 pt-0 sm:pt-0 md:pt-0 lg:pt-6 pb-4'>
                  <div className='flex flex-col text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                    <label className='block mb-1 text-[#1A1A1A]'>Customer Group</label>
                    <Select
                      className='basic-single'
                      classNamePrefix='select'
                      value={states.selectedCustomerGroup}
                      onChange={handleCustomerGroup}
                      isClearable={true}
                      isSearchable={true}
                      name='customerGroup'
                      options={states.customerGroupOptions}
                      placeholder='Select Customer Group'
                      isDisabled={false}
                      isLoading={false}
                      isRtl={false}
                    />
                    {states.errors.customerGroup && <p className='text-red-500'>{states.errors.customerGroup}</p>}
                  </div>
                </div>
                <div className='gap-4 px-4 sm:px-4 md:px-6 lg:px-6   pb-4'>
                  <div className='flex flex-col text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                    <label className='block mb-1 text-[#1A1A1A]'>Business Type</label>
                    <Select
                      className='basic-single'
                      classNamePrefix='select'
                      value={states.selectedBusinessType}
                      onChange={handleChangeBusineType}
                      isClearable={true}
                      isSearchable={true}
                      name='businessType'
                      options={states.businessTypeOptions}
                      placeholder='Select Business Type'
                      isDisabled={false}
                      isLoading={false}
                      isRtl={false}
                    />
                    {states.errors.businessType && <p className='text-red-500'>{states.errors.businessType}</p>}
                  </div>
                </div>
                <div className='px-4 sm:px-4 md:px-6 lg:px-6  pb-4'>
                  <div className='grid grid-cols-2 gap-4 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                    <div className='flex flex-col'>
                      <label className='block mb-1 text-[#1A1A1A]'>Opening Time</label>
                      <input
                        type='time'
                        name='openingTimeFrom'
                        value={states.formData.openingTimeFrom || ''}
                        onChange={handleChange}
                        className='border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg'
                      />
                      {states.errors.openingTimeFrom && <p className='text-red-500'>{states.errors.openingTimeFrom}</p>}
                    </div>

                    <div className='flex flex-col'>
                      <label className='block mb-1 text-[#1A1A1A]'>Closing Time</label>
                      <input
                        type='time'
                        name='openingTimeTo'
                        value={states.formData.openingTimeTo || ''}
                        onChange={handleChange}
                        className='border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg'
                      />
                      {states.errors.openingTimeTo && <p className='text-red-500'>{states.errors.openingTimeTo}</p>}
                    </div>
                  </div>
                </div>

                <div className='px-4 sm:px-4 md:px-6 lg:px-6  pb-4'>
                  <label className='block sm:block md:hidden lg:hidden text-sm sm:text-sm md:text-base lg:text-base mb-1 font-poppins'>
                    Preferable Delivery Time
                  </label>
                  <div className='grid grid-cols-2 gap-4 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                    <div className='flex flex-col'>
                      <label className='hidden sm:hidden md:block lg:block mb-1 text-[#1A1A1A]'>
                        Preferable Delivery Time From
                      </label>
                      <input
                        type='time'
                        name='deliveryTimeFrom'
                        value={states.formData.deliveryTimeFrom || ''}
                        onChange={handleChange}
                        className='border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg'
                      />
                      {states.errors.deliveryTimeFrom && (
                        <p className='text-red-500'>{states.errors.deliveryTimeFrom || '\u00A0'}</p>
                      )}
                    </div>

                    <div className='flex flex-col'>
                      <label className='hidden sm:hidden md:block lg:block mb-1 text-[#1A1A1A]'>
                        Preferable Delivery Time To
                      </label>
                      <input
                        type='time'
                        name='deliveryTimeTo'
                        value={states.formData.deliveryTimeTo || ''}
                        onChange={handleChange}
                        className='border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg'
                      />
                      {states.errors.deliveryTimeTo && (
                        <p className='text-red-500'>{states.errors.deliveryTimeTo || '\u00A0'}</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Submit Button */}
              <div className='text-left  px-4 sm:px-4 md:px-4 lg:px-0'>
                <button
                  type='submit'
                  className='min-w-full sm:min-w-full md:min-w-full lg:min-w-[0rem] bg-red-700 hover:bg-red-800 text-white px-8 py-3 rounded-xl font-poppins font-medium transition'
                >
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfilePage;
